<template>
  <div class="login">
    <div class="loginContent">
      <div class="LoginMenu">
        <div class="menuBtn" @click="toRouter('/studyLogin')">
          学习账号登录
        </div>
      </div>
      <div class="LoginMenu">
        <div class="menuBtn" @click="toWindows">
          管理员登录
        </div>
      </div>
      <div class="LoginMenu">
        <div class="menuBtn">
          关于我们
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'login',
  methods:{
    toRouter(path){
      this.$router.push({path:path})
    },
    toWindows(){
      window.open('https://englishadmin.jacknum1.top')
    }
  }
}
</script>
<style scoped lang="scss">
.login{
  width: 100%;
  height: 100vh;
  background-image: url('@/assets/indexBgImage.webp');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center;

  .loginContent{
    width: 100%;
    height: 100px;
    display: flex;
    padding: 0 10%;

    .LoginMenu{
      width: 33.33%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;

      .menuBtn{
        width: 200px;
        height: 30px;
        background: #FF7B00;
        color: #fff;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        border-radius: 8px;
        font-size: 20px;
        font-weight: 800;
        line-height: 24px;
        text-align: center;
        letter-spacing: 1px;
        cursor: pointer;
      }
    }
  }

}
</style>
